import React__default from 'react';
import createContextUtilities from '../../utils/createContextUtilities/3841674170c200f7bdd32cb74e68b517c71ba9e78ccd1beac3d76de81e3e2a5c.cfe-internal.js';

function createContextValue(value) {
  return {
    className: value.className,
    inputClassName: value.inputClassName,
    applySmall: function applySmall(small) {
      return value.small || small;
    },
    applyFull: function applyFull(full) {
      if (value.overrideFull) {
        return false;
      }

      return full;
    }
  };
}

var _createContextUtiliti = createContextUtilities(createContextValue({})),
    InputGroupContextProvider = _createContextUtiliti.Provider,
    useInputGroupContext = _createContextUtiliti.useContext;

var InputGroupProvider = function InputGroupProvider(_ref) {
  var children = _ref.children,
      value = _ref.value;
  var context = createContextValue(value);
  return /*#__PURE__*/React__default.createElement(InputGroupContextProvider, {
    value: context
  }, children);
};

export { InputGroupProvider, useInputGroupContext };
